// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Hotspot-module--fade-in-animation--7266b";
export var hotspot = "Hotspot-module--hotspot--80a79";
export var wrapper = "Hotspot-module--wrapper--c85ef";